import { CalendarToday as CalendarIcon } from '@mui/icons-material'
import { TextField, InputAdornment } from '@mui/material'

interface DatePickerProps {
  readonly value: string
  readonly onChange: (date: string) => void
  readonly placeholder?: string
  readonly label?: string
  readonly disabled?: boolean
  readonly error?: boolean
  readonly helperText?: string
  readonly min?: string
}

export function DatePicker({
  value,
  onChange,
  placeholder,
  label,
  disabled = false,
  error = false,
  helperText,
  min,
}: DatePickerProps) {
  return (
    <TextField
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      label={label}
      placeholder={placeholder}
      fullWidth
      disabled={disabled}
      error={error}
      helperText={helperText}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <CalendarIcon sx={{ color: 'rgba(255, 255, 255, 0.5)' }} />
          </InputAdornment>
        ),
      }}
      inputProps={{
        min,
      }}
      sx={{
        '& input[type="date"]::-webkit-calendar-picker-indicator': {
          opacity: 0,
          position: 'absolute',
          width: '100%',
          height: '100%',
          cursor: disabled ? 'default' : 'pointer',
        },
        '& input[type="date"]': {
          cursor: disabled ? 'default' : 'pointer',
          colorScheme: 'dark',
        },
      }}
    />
  )
}
